import { createFileRoute } from '@tanstack/react-router';
import { type ReactNode, useMemo } from 'react';
import { z } from 'zod';
import type { ScopeState } from '../../components/filters/types.js';
import { useScopeSelection } from '../../components/filters/useScopeSelection.js';
import { OutcomesPage } from '../../components/outcomes/OutcomesPage.js';
import {
  mergeScopeIntoSearch,
  scopeFromSearch,
  scopeSearchShape,
  searchHasScope,
} from '../../lib/scope-search.js';

function OutcomesRoute(): ReactNode {
  const navigate = Route.useNavigate();
  const search = Route.useSearch();
  const scopeSearch = useMemo(() => scopeFromSearch(search), [search]);
  const hasScope = searchHasScope(search);
  const setUrlScope = (next: ScopeState): void => {
    void navigate({
      replace: true,
      search: (previous) => mergeScopeIntoSearch(previous, next),
    });
  };
  const { scope, applyScope } = useScopeSelection({
    scope: scopeSearch,
    onScopeChange: setUrlScope,
    urlHasScope: hasScope,
  });

  return (
    <OutcomesPage
      scope={scope}
      onScopeChange={applyScope}
      openRunId={search.openRunId ?? null}
      openBrief={search.openBrief ?? null}
    />
  );
}

export const Route = createFileRoute('/outcomes/')({
  validateSearch: (search: Record<string, unknown>) => ({
    ...z.object(scopeSearchShape).catch({}).parse(search),
    ...z
      .object({
        openRunId: z.string().optional().catch(undefined),
        openBrief: z.string().optional().catch(undefined),
      })
      .catch({})
      .parse(search),
  }),
  component: OutcomesRoute,
});
